var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdispatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FEF2D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12V22C25 23.1 24.1 24 23 24H12V17.62C12.73 18.49 13.85 19.03 15.09 19C16.1 18.98 17.01 18.59 17.69 17.94C18 17.68 18.26 17.35 18.46 16.99C18.82 16.38 19.02 15.66 19 14.91C18.97 13.74 18.45 12.71 17.64 12H25Z",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.29 19H29C28.45 19 28 19.45 28 20V23C28 23.55 28.45 24 29 24H32V27C32 28.66 30.66 30 29 30H28C28 28.9 27.1 28 26 28C24.9 28 24 28.9 24 30H20C20 28.9 19.1 28 18 28C16.9 28 16 28.9 16 30H15C13.94 30 13.01 29.45 12.48 28.63",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H23C24.1 24 25 23.1 25 22V15H26.84C27.2 15 27.55 15.1 27.85 15.27",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C19.1046 32 20 31.1046 20 30C20 28.8954 19.1046 28 18 28C16.8954 28 16 28.8954 16 30C16 31.1046 16.8954 32 18 32Z",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32C27.1046 32 28 31.1046 28 30C28 28.8954 27.1046 28 26 28C24.8954 28 24 28.8954 24 30C24 31.1046 24.8954 32 26 32Z",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22V24H29C28.45 24 28 23.55 28 23V20C28 19.45 28.45 19 29 19H30.29L32 22Z",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.9097C19.02 15.6597 18.82 16.3798 18.46 16.9898C18.26 17.3498 18 17.6798 17.69 17.9398C17.01 18.5898 16.1 18.9798 15.09 18.9998C13.85 19.0298 12.73 18.4898 12 17.6198C11.86 17.4698 11.74 17.2998 11.63 17.1298C11.24 16.5398 11.02 15.8398 11 15.0898C10.97 13.8298 11.53 12.6798 12.43 11.9298C13.11 11.3698 13.97 11.0198 14.91 10.9998C15.96 10.9798 16.92 11.3598 17.64 11.9998C18.45 12.7098 18.97 13.7397 19 14.9097Z",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.44 15.0298L14.45 15.9897L16.54 13.9697",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdispatched);
export default __webpack_public_path__ + "static/media/odispatched.3f6f3396d6e1950995ae627a5be4c7f2.svg";
export { ForwardRef as ReactComponent };